// extracted by css-extract-rspack-plugin
export default {"dropdown":"Controls-module__dropdown___Tk8Wp","label":"Controls-module__label___jeIGu","delivery":"Controls-module__delivery___UiAcg"};